import React from 'react';
import { ProsCons } from '../ProsCons';
import { getAvaliabilityIcon } from './getAvaliabilityIcon';
import { DisplayGroup } from './groupInterfaces';
import { Services } from '@kizi/comparator-core';

export const getDataLimit = (limit: string) => {
  switch (limit) {
    case '-1':
      return 'Niet van toepassing';
    case 'fup':
      return 'Fair Use Policy';
    case 'onbeperkt':
      return 'Onbeperkt';
    default:
      return `${limit} MB`;
  }
};

export const sizeOfEmailBox = (size: string) => {
  if (size === '0') {
    return {
      value: <ProsCons ml="-10px" data={[['']]} onlyCons={true} />,
    };
  }

  return {
    value: `${size} MB`,
  };
};

export const getNetworkInformationGroup = (
  networkInformation: Services['networkInformation']
): DisplayGroup[] => {
  if (!networkInformation) {
    return [];
  }

  const {
    internetSpeed: { downloadSpeedInMb, uploadSpeedInMb },
    modems: { modem },
    network,
    dataLimit,
    email: {
      emailBoxes,
      webmail,
      numberOfAliasesPerBox,
      spamFilter,
      virusFilter,
    },
    homepage,
    newsgroups,
    fixedIp,
    ownServer,
  } = networkInformation;

  return [
    {
      label: 'Downloadsnelheid',
      tooltip:
        'De maximale downloadsnelheid die haalbaar is met dit pakket. Let op: de werkelijke downloadsnelheid kan hiervan afwijken.',
      value: `${downloadSpeedInMb} Mb/s`,
    },
    {
      label: 'Uploadsnelheid',
      tooltip:
        'De maximale uploadsnelheid die haalbaar is met dit pakket. Let op: de werkelijke uploadsnelheid kan hiervan afwijken.',
      value: `${uploadSpeedInMb} Mb/s`,
    },
    {
      label: 'Netwerk',
      tooltip: 'Het netwerk waarover de aanbieder de verbinding levert.',
      value: network.signal.toUpperCase(),
    },
    {
      label: 'Aantal e-mailboxen',
      tooltip:
        'Het aantal inbegrepen e-mailboxen met unieke loginnaam en wachtwoord.',
      value: emailBoxes.numberOfEmailBoxes,
    },
    {
      label: 'Grootte e-mailbox',
      tooltip: 'De hoeveelheid e-mails die je kunt opslaan in MB of GB.',
      ...sizeOfEmailBox(emailBoxes.sizeOfEmailBox),
    },
    {
      label: 'Modems',
      tooltip: 'De modem(s) of ontvanger(s) die deze aanbieder meelevert.',
      value: modem[0].name,
    },
    {
      label: 'Datalimiet',
      tooltip:
        'De maximale hoeveelheid data die je mag gebruiken. In geval van een Fair Use Policy geldt er geen harde limiet, maar kijkt de aanbieder of je dataverbruik niet te veel afwijkt van het gemiddelde verbruik.',
      value: getDataLimit(dataLimit.limiet),
    },
    {
      label: 'Webmail',
      tooltip:
        'Met webmail kun je met behulp van een internetbrowser overal ter wereld je e-mail lezen.',
      value: getAvaliabilityIcon(webmail),
    },
    {
      label: 'E-mailaliassen per box',
      tooltip: 'Het aantal inbegrepen e-mailadressen.',
      value: numberOfAliasesPerBox,
    },
    {
      label: 'E-mail Spamfilter',
      tooltip:
        'Een spamfilter verwijdert automatisch ongewenste reclame uit binnengekomen e-mail.',
      value: getAvaliabilityIcon(spamFilter),
    },
    {
      label: 'E-mail Virusfilter',
      tooltip:
        'Een virusfilter verwijdert automatisch virussen uit binnengekomen e-mail.',
      value: getAvaliabilityIcon(virusFilter),
    },
    {
      label: 'Homepage',
      tooltip:
        'Sommige aanbieders geven je de mogelijkheid gratis een homepage te publiceren.',
      value: getAvaliabilityIcon(homepage),
    },
    {
      label: 'Nieuwsgroepen',
      tooltip:
        'In een nieuwsgroep kun je bestanden uitwisselen en discussiëren met medegebruikers.',
      value: getAvaliabilityIcon(newsgroups),
    },
    {
      label: 'Vast IP-adres',
      tooltip:
        'Een vast IP-adres is handig als je een eigen web- of mailserver wilt gebruiken.',
      value: getAvaliabilityIcon(fixedIp),
    },

    {
      label: 'Eigen server toegestaan',
      tooltip: 'Bijvoorbeeld een eigen web- of mailserver.',
      value: getAvaliabilityIcon(ownServer),
    },
  ];
};
